// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Workplan,
} from './';

export default {
  path: 'workplan',
  name: 'Workplan',
  childRoutes: [
    { path: 'workplan', name: 'Workplan', component: Workplan, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/workplan/route.js